import { combineEpics } from "redux-observable";

import { queryEpic } from "../components/filters/ducks";
import { populateResourceEpic } from "../components/map/ducks";
import {
  initialLoadReady$,
  dataStream$,
  loadResourcesData,
} from "../components/data/ducks";

export default combineEpics(
  initialLoadReady$,
  queryEpic,
  populateResourceEpic,
  loadResourcesData,
  dataStream$
);



// WEBPACK FOOTER //
// ./src/store/epics.js